import WorkoutDaysRepeater from './WorkoutDaysRepeater';

export default WorkoutDaysRepeater;
